itsoftApp.createModule("portfolio", function() {
    var item = $(".js-portfolio-2 ");
    if (!item.length) {
        return false;
    }

    var title = $(".js-portfolio-title");

    item.on("mouseenter", function(){
        title.addClass("g-hidden");
    })

    item.on("mouseleave", function(){
        title.removeClass("g-hidden");
    })
});